import {
  statusBadgeClass as sharedStatusBadgeClass,
  statusTone as sharedStatusTone,
} from "../../utils/statusBadge";

// Mirrors backend settings.matching_supply_threshold default (MATCHING_SUPPLY_THRESHOLD env var)
const APPROVAL_THRESHOLD = 0.6;

export function scorePct(score) {
  if (score == null) return "—";
  return `${Math.round(score * 100)} %`;
}

export function statusLabel(result) {
  const hasZDoc = Boolean(result.z_document_id);
  const noOutcome = result.approved === null || result.approved === undefined;

  if (!hasZDoc) return "no-z-doc";
  if (noOutcome) return "error";
  if (result.score == null || result.score === 0) return "out-of-scope";
  return result.score >= APPROVAL_THRESHOLD ? "within-scope" : "partial";
}

// Approval label → canonical status understood by the shared badge mapping
// (utils/statusBadge.js), so approval states colour like every other status.
// "no-z-doc" has no outcome and stays neutral.
const LABEL_STATUS = {
  "within-scope": "approved",
  "partial":      "partial",
  "out-of-scope": "rejected",
  "error":        "error",
};

/** Design-system tone ("success" | "warning" | "danger" | null) for an approval label. */
export function statusTone(label) {
  return sharedStatusTone(LABEL_STATUS[label]);
}

/** Design-system badge class for an approval label. */
export function statusBadgeClass(label) {
  return sharedStatusBadgeClass(LABEL_STATUS[label]);
}

export function statusText(label) {
  return {
    "within-scope": "✓ Within scope",
    "partial":       "⚠ Partial",
    "out-of-scope":  "✗ Out of scope",
    "no-z-doc":      "— No Z-doc found",
    "error":         "⚠ Extraction error",
  }[label] ?? "—";
}
